import { TransformEvaluationVisitorAdapter } from '../../TransformVisitor';
import { applyTemplate } from '../../utils/stringTemplate';
import { createValidityVisitor } from './ValidityVisitor';
export function buildValidationErrorMessage(evaluatedRule) {
    const { message, evaluatedMessageParams } = evaluatedRule;
    let evaluatedMessage = '';
    if (message && typeof message === 'string') {
        evaluatedMessage = applyTemplate(message, evaluatedMessageParams);
    }
    else {
        throw new Error('A message or message key must be defined for a ValidityRule.');
    }
    return evaluatedMessage;
}
function transformItemsValidity(questionnaire, answersResolver, text, { shouldValidateAllAnswers }, timezone, currentDateOverride) {
    const validityVisitor = createValidityVisitor({
        processFieldEvaluation: ({ node, hasBeenAnswered, brokenRules, validationData }) => {
            const isValid = brokenRules.length === 0;
            node.valid = node.valid && isValid;
            node.validationData = validationData;
            const shouldSetValidationMessage = shouldValidateAllAnswers || hasBeenAnswered;
            if (!isValid && shouldSetValidationMessage && !node.validationError) {
                const firstBrokenRule = brokenRules[0];
                node.validationError = { message: buildValidationErrorMessage(firstBrokenRule) };
            }
        },
    }, answersResolver, timezone, currentDateOverride);
    const visitorAdapter = new TransformEvaluationVisitorAdapter(answersResolver, validityVisitor);
    visitorAdapter.visitQuestionnaire(questionnaire);
    return questionnaire;
}
export { transformItemsValidity };
